import { SxProps, Theme } from '@mui/material';

export const stylesBoxChoice: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyItems: 'center',
  alignItems: 'center',
  position: 'relative',
  border: 1,
  height: '100%',
  borderRadius: 1.5,
  borderColor: 'primary.light',
  p: 4,
  '&:hover': {
    cursor: 'pointer',
  },
  '&.disabled:after': {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    background: 'white',
    opacity: 0.6,
    content: '""',
  },
};
export const stylesBoxChoiceHeading: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
};

export const stylesBoxChoiceContent: SxProps<Theme> = { width: '100%', flex: 1, pt: 4 };
export const stylesBoxChoiceSubDescription: SxProps<Theme> = { py: 2, color: 'grey.500' };
export const stylesBoxChoiceBtnIcon: SxProps<Theme> = { fontSize: 'bodyXLBold.fontSize', pl: '0.5rem' };
export const stylesBoxChoiceComingSoon: SxProps<Theme> = {
  position: 'absolute',
  display: 'inline-block',
  width: 'fit-content',
  whiteSpace: 'nowrap',
  transform: 'translate(-50%)',
  left: '50%',
  top: '50%',
  pl: '0.5rem',
  color: 'grey.700',
  backgroundColor: 'grey.300',
  borderRadius: '6px',
  py: 1,
  px: 2,
  zIndex: 1,
};
export const stylesBoxChoiceList: SxProps<Theme> = { p: 0 };
export const stylesBoxChoiceListItem: SxProps<Theme> = {
  width: '100%',
  pl: 0,
  py: 0.5,
  ml: -1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
};
